// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Live mode tools: coach mode strip, interval timer, match scoreboard, player live card.
   Work phases use the club brand colour, rest phases a calm teal so the state reads across the hall. */

.lt-mode-strip,
.lt-interval,
.lt-mode-live {
  --lt-mode-work: var(--lt-brand, #0877bc);
  --lt-mode-rest: #14b8a6;
  --lt-mode-done: #f59e0b;
}

/* ---- Coach mode strip ---- */
.lt-mode-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.86);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-left: 3px solid var(--lt-brand, #0877bc);
  flex-wrap: wrap;
  flex-shrink: 0;
}

.lt-mode-strip--multiball { border-left-color: #f97316; }
.lt-mode-strip--match { border-left-color: #eab308; }
.lt-mode-strip--interval { border-left-color: var(--lt-mode-rest); }
.lt-mode-strip--off_table { border-left-color: #22c55e; }
.lt-mode-strip--kot { border-left-color: #a855f7; }

.lt-mode-strip__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: #e2e8f0;
  flex-shrink: 0;
}

.lt-mode-strip__text {
  flex: 1 1 220px;
  min-width: 0;
}

.lt-mode-strip__title {
  margin: 0;
  font-size: 0.86rem;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.lt-mode-strip__brief {
  margin: 2px 0 0;
  font-size: 0.76rem;
  line-height: 1.3;
  color: rgba(226, 232, 240, 0.78);
}

.lt-mode-strip__actions {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.lt-mode-strip__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  min-height: 40px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  color: #e2e8f0;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
}

.lt-mode-strip__btn:hover,
.lt-mode-strip__btn--primary {
  background: var(--lt-brand, #0877bc);
  border-color: var(--lt-brand, #0877bc);
  color: #fff;
}

.lt-mode-strip__btn:focus-visible,
.lt-interval__preset:focus-visible,
.lt-match__points:focus-visible,
.lt-match__bestof-btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.lt-mode-strip__btn--live.lt-mode-strip__btn--work {
  background: var(--lt-mode-work);
  border-color: var(--lt-mode-work);
  color: #fff;
}

.lt-mode-strip__btn--live.lt-mode-strip__btn--rest {
  background: var(--lt-mode-rest);
  border-color: var(--lt-mode-rest);
  color: #04201d;
}

.lt-mode-strip__readout {
  font-variant-numeric: tabular-nums;
}

.lt-mode-strip__badge {
  padding: 1px 7px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.28);
  font-size: 0.72rem;
}

/* ---- Interval timer sheet ---- */
.lt-interval__body {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.lt-interval__dial {
  position: relative;
  width: min(240px, 70vw);
  aspect-ratio: 1;
  margin: 0 auto;
  --lt-dial-color: rgba(255, 255, 255, 0.35);
}

.lt-interval__dial--work { --lt-dial-color: var(--lt-mode-work); }
.lt-interval__dial--rest { --lt-dial-color: var(--lt-mode-rest); }
.lt-interval__dial--done { --lt-dial-color: var(--lt-mode-done); }

.lt-interval__dial svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.lt-interval__dial-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.08);
  stroke-width: 8;
}

.lt-interval__dial-arc {
  fill: none;
  stroke: var(--lt-dial-color);
  stroke-width: 8;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.25s linear, stroke 0.3s ease;
}

.lt-interval__dial-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.lt-interval__phase {
  font-size: 0.8rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--lt-dial-color);
}

.lt-interval__clock {
  font-size: clamp(2.4rem, 11vw, 3.4rem);
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.lt-interval__round {
  font-size: 0.8rem;
  color: rgba(226, 232, 240, 0.75);
}

.lt-interval__controls {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.lt-interval__main-btn {
  min-width: 132px;
  justify-content: center;
}

.lt-interval__config[aria-disabled="true"] {
  opacity: 0.55;
}

.lt-interval__presets {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 8px;
}

.lt-interval__preset {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border-radius: 10px;
  text-align: left;
  cursor: pointer;
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-interval__preset span {
  font-size: 0.72rem;
  color: rgba(226, 232, 240, 0.7);
  font-variant-numeric: tabular-nums;
}

.lt-interval__preset--active {
  border-color: var(--lt-brand, #0877bc);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);
}

.lt-interval__preset:disabled {
  cursor: not-allowed;
}

.lt-interval__steppers {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.lt-interval__stepper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.lt-interval__stepper-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(226, 232, 240, 0.7);
}

.lt-interval__stepper-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lt-interval__stepper-value {
  min-width: 44px;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.lt-interval__stepper-value small {
  font-size: 0.7rem;
  margin-left: 1px;
  opacity: 0.7;
}

/* ---- Match scoreboard sheet ---- */
.lt-match__body {
  padding: 12px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lt-match__toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.lt-match__bestof {
  display: inline-flex;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.lt-match__bestof-btn {
  min-width: 40px;
  min-height: 34px;
  border: none;
  background: transparent;
  color: #e2e8f0;
  font-weight: 800;
  cursor: pointer;
}

.lt-match__bestof-btn--active {
  background: var(--lt-brand, #0877bc);
  color: #fff;
}

.lt-match__summary {
  margin-left: auto;
  font-size: 0.76rem;
  color: rgba(226, 232, 240, 0.75);
}

.lt-match__tables {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.lt-match__table {
  padding: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-match__table--done {
  border-color: color-mix(in srgb, #eab308 55%, transparent);
}

.lt-match__table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.lt-match__table-no {
  font-size: 0.74rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: rgba(226, 232, 240, 0.75);
}

.lt-match__sets {
  display: inline-flex;
  gap: 6px;
  flex-wrap: wrap;
}

.lt-match__set {
  padding: 1px 6px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  font-size: 0.72rem;
  font-variant-numeric: tabular-nums;
}

.lt-match__duel {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 8px;
}

.lt-match__vs {
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  color: rgba(226, 232, 240, 0.5);
}

.lt-match__side {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.lt-match__name {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  font-weight: 700;
  font-size: 0.84rem;
}

.lt-match__name span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-match__side--winner .lt-match__name {
  color: #facc15;
}

.lt-match__games {
  font-size: 0.72rem;
  font-weight: 800;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  font-variant-numeric: tabular-nums;
}

.lt-match__points-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lt-match__points {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 76px;
  min-height: 60px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 24%, #0f172a);
  color: #fff;
  font-size: 2rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  touch-action: manipulation;
}

.lt-match__points .MuiSvgIcon-root {
  font-size: 1rem;
  opacity: 0.6;
}

.lt-match__points:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.lt-match__table-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.lt-match__footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

/* ---- Player live card ---- */
.lt-mode-live {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 8px 12px;
}

.lt-mode-live__interval,
.lt-mode-live__match {
  flex: 1 1 240px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 14px;
  color: #fff;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-mode-live__interval--work { background: var(--lt-mode-work); }
.lt-mode-live__interval--rest { background: var(--lt-mode-rest); color: #04201d; }
.lt-mode-live__interval--done { background: var(--lt-mode-done); color: #1c1203; }

.lt-mode-live__phase {
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.82rem;
}

.lt-mode-live__clock {
  font-size: 2.2rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  margin-left: auto;
}

.lt-mode-live__round {
  font-size: 0.78rem;
  opacity: 0.85;
}

.lt-mode-live__match {
  flex-wrap: wrap;
}

.lt-mode-live__table {
  width: 100%;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  opacity: 0.75;
}

.lt-mode-live__side {
  flex: 1 1;
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.lt-mode-live__side--me .lt-mode-live__name {
  color: #7dd3fc;
}

.lt-mode-live__side--winner .lt-mode-live__name {
  color: #facc15;
}

.lt-mode-live__name {
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-mode-live__games {
  font-size: 0.76rem;
  padding: 1px 7px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
}

.lt-mode-live__points {
  font-size: 1.6rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.lt-mode-live__sets {
  width: 100%;
  font-size: 0.74rem;
  opacity: 0.75;
  font-variant-numeric: tabular-nums;
}

@media (prefers-reduced-motion: reduce) {
  .lt-interval__dial-arc {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingModeTools.css"],"names":[],"mappings":"AAAA;uGACuG;;AAEvG;;;EAGE,wCAAwC;EACxC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,+CAA+C;EAC/C,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B,0BAA0B,EAAE;AACxD,wBAAwB,0BAA0B,EAAE;AACpD,2BAA2B,sCAAsC,EAAE;AACnE,4BAA4B,0BAA0B,EAAE;AACxD,sBAAsB,0BAA0B,EAAE;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yEAAyE;EACzE,+EAA+E;AACjF;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;;;;EAIE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,0CAA0C;AAC5C;;AAEA,2BAA2B,oCAAoC,EAAE;AACjE,2BAA2B,oCAAoC,EAAE;AACjE,2BAA2B,oCAAoC,EAAE;;AAEjE;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+EAA+E;EAC/E,qEAAqE;EACrE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA,gCAAgC,+BAA+B,EAAE;AACjE,gCAAgC,+BAA+B,EAAE,cAAc,EAAE;AACjF,gCAAgC,+BAA+B,EAAE,cAAc,EAAE;;AAEjF;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,SAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Live mode tools: coach mode strip, interval timer, match scoreboard, player live card.\n   Work phases use the club brand colour, rest phases a calm teal so the state reads across the hall. */\n\n.lt-mode-strip,\n.lt-interval,\n.lt-mode-live {\n  --lt-mode-work: var(--lt-brand, #0877bc);\n  --lt-mode-rest: #14b8a6;\n  --lt-mode-done: #f59e0b;\n}\n\n/* ---- Coach mode strip ---- */\n.lt-mode-strip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.86);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-left: 3px solid var(--lt-brand, #0877bc);\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.lt-mode-strip--multiball { border-left-color: #f97316; }\n.lt-mode-strip--match { border-left-color: #eab308; }\n.lt-mode-strip--interval { border-left-color: var(--lt-mode-rest); }\n.lt-mode-strip--off_table { border-left-color: #22c55e; }\n.lt-mode-strip--kot { border-left-color: #a855f7; }\n\n.lt-mode-strip__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.06);\n  color: #e2e8f0;\n  flex-shrink: 0;\n}\n\n.lt-mode-strip__text {\n  flex: 1 1 220px;\n  min-width: 0;\n}\n\n.lt-mode-strip__title {\n  margin: 0;\n  font-size: 0.86rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n}\n\n.lt-mode-strip__brief {\n  margin: 2px 0 0;\n  font-size: 0.76rem;\n  line-height: 1.3;\n  color: rgba(226, 232, 240, 0.78);\n}\n\n.lt-mode-strip__actions {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.lt-mode-strip__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  min-height: 40px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 0.8rem;\n  cursor: pointer;\n  color: #e2e8f0;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n}\n\n.lt-mode-strip__btn:hover,\n.lt-mode-strip__btn--primary {\n  background: var(--lt-brand, #0877bc);\n  border-color: var(--lt-brand, #0877bc);\n  color: #fff;\n}\n\n.lt-mode-strip__btn:focus-visible,\n.lt-interval__preset:focus-visible,\n.lt-match__points:focus-visible,\n.lt-match__bestof-btn:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n}\n\n.lt-mode-strip__btn--live.lt-mode-strip__btn--work {\n  background: var(--lt-mode-work);\n  border-color: var(--lt-mode-work);\n  color: #fff;\n}\n\n.lt-mode-strip__btn--live.lt-mode-strip__btn--rest {\n  background: var(--lt-mode-rest);\n  border-color: var(--lt-mode-rest);\n  color: #04201d;\n}\n\n.lt-mode-strip__readout {\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-mode-strip__badge {\n  padding: 1px 7px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.28);\n  font-size: 0.72rem;\n}\n\n/* ---- Interval timer sheet ---- */\n.lt-interval__body {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.lt-interval__dial {\n  position: relative;\n  width: min(240px, 70vw);\n  aspect-ratio: 1;\n  margin: 0 auto;\n  --lt-dial-color: rgba(255, 255, 255, 0.35);\n}\n\n.lt-interval__dial--work { --lt-dial-color: var(--lt-mode-work); }\n.lt-interval__dial--rest { --lt-dial-color: var(--lt-mode-rest); }\n.lt-interval__dial--done { --lt-dial-color: var(--lt-mode-done); }\n\n.lt-interval__dial svg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.lt-interval__dial-bg {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.08);\n  stroke-width: 8;\n}\n\n.lt-interval__dial-arc {\n  fill: none;\n  stroke: var(--lt-dial-color);\n  stroke-width: 8;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.25s linear, stroke 0.3s ease;\n}\n\n.lt-interval__dial-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n}\n\n.lt-interval__phase {\n  font-size: 0.8rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--lt-dial-color);\n}\n\n.lt-interval__clock {\n  font-size: clamp(2.4rem, 11vw, 3.4rem);\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.lt-interval__round {\n  font-size: 0.8rem;\n  color: rgba(226, 232, 240, 0.75);\n}\n\n.lt-interval__controls {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.lt-interval__main-btn {\n  min-width: 132px;\n  justify-content: center;\n}\n\n.lt-interval__config[aria-disabled=\"true\"] {\n  opacity: 0.55;\n}\n\n.lt-interval__presets {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n  gap: 8px;\n}\n\n.lt-interval__preset {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  text-align: left;\n  cursor: pointer;\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-interval__preset span {\n  font-size: 0.72rem;\n  color: rgba(226, 232, 240, 0.7);\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-interval__preset--active {\n  border-color: var(--lt-brand, #0877bc);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);\n}\n\n.lt-interval__preset:disabled {\n  cursor: not-allowed;\n}\n\n.lt-interval__steppers {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.lt-interval__stepper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.lt-interval__stepper-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(226, 232, 240, 0.7);\n}\n\n.lt-interval__stepper-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.lt-interval__stepper-value {\n  min-width: 44px;\n  text-align: center;\n  font-size: 1.1rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-interval__stepper-value small {\n  font-size: 0.7rem;\n  margin-left: 1px;\n  opacity: 0.7;\n}\n\n/* ---- Match scoreboard sheet ---- */\n.lt-match__body {\n  padding: 12px 14px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.lt-match__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.lt-match__bestof {\n  display: inline-flex;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n}\n\n.lt-match__bestof-btn {\n  min-width: 40px;\n  min-height: 34px;\n  border: none;\n  background: transparent;\n  color: #e2e8f0;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.lt-match__bestof-btn--active {\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n}\n\n.lt-match__summary {\n  margin-left: auto;\n  font-size: 0.76rem;\n  color: rgba(226, 232, 240, 0.75);\n}\n\n.lt-match__tables {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 10px;\n}\n\n.lt-match__table {\n  padding: 10px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-match__table--done {\n  border-color: color-mix(in srgb, #eab308 55%, transparent);\n}\n\n.lt-match__table-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.lt-match__table-no {\n  font-size: 0.74rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: rgba(226, 232, 240, 0.75);\n}\n\n.lt-match__sets {\n  display: inline-flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.lt-match__set {\n  padding: 1px 6px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.08);\n  font-size: 0.72rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-match__duel {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 8px;\n}\n\n.lt-match__vs {\n  font-size: 0.72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: rgba(226, 232, 240, 0.5);\n}\n\n.lt-match__side {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.lt-match__name {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 100%;\n  font-weight: 700;\n  font-size: 0.84rem;\n}\n\n.lt-match__name span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-match__side--winner .lt-match__name {\n  color: #facc15;\n}\n\n.lt-match__games {\n  font-size: 0.72rem;\n  font-weight: 800;\n  padding: 1px 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-match__points-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.lt-match__points {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  min-width: 76px;\n  min-height: 60px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 24%, #0f172a);\n  color: #fff;\n  font-size: 2rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n  touch-action: manipulation;\n}\n\n.lt-match__points .MuiSvgIcon-root {\n  font-size: 1rem;\n  opacity: 0.6;\n}\n\n.lt-match__points:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.lt-match__table-actions {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.lt-match__footer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n/* ---- Player live card ---- */\n.lt-mode-live {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 8px 12px;\n}\n\n.lt-mode-live__interval,\n.lt-mode-live__match {\n  flex: 1 1 240px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 14px;\n  color: #fff;\n  background: rgba(15, 23, 42, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-mode-live__interval--work { background: var(--lt-mode-work); }\n.lt-mode-live__interval--rest { background: var(--lt-mode-rest); color: #04201d; }\n.lt-mode-live__interval--done { background: var(--lt-mode-done); color: #1c1203; }\n\n.lt-mode-live__phase {\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  font-size: 0.82rem;\n}\n\n.lt-mode-live__clock {\n  font-size: 2.2rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n  margin-left: auto;\n}\n\n.lt-mode-live__round {\n  font-size: 0.78rem;\n  opacity: 0.85;\n}\n\n.lt-mode-live__match {\n  flex-wrap: wrap;\n}\n\n.lt-mode-live__table {\n  width: 100%;\n  font-size: 0.72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  opacity: 0.75;\n}\n\n.lt-mode-live__side {\n  flex: 1 1 0;\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.lt-mode-live__side--me .lt-mode-live__name {\n  color: #7dd3fc;\n}\n\n.lt-mode-live__side--winner .lt-mode-live__name {\n  color: #facc15;\n}\n\n.lt-mode-live__name {\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-mode-live__games {\n  font-size: 0.76rem;\n  padding: 1px 7px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.lt-mode-live__points {\n  font-size: 1.6rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-mode-live__sets {\n  width: 100%;\n  font-size: 0.74rem;\n  opacity: 0.75;\n  font-variant-numeric: tabular-nums;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lt-interval__dial-arc {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
